import { motion } from 'framer-motion';

export type LanguageCode = 'pt-BR' | 'en-US' | 'es-ES';

interface LanguageSwitcherProps {
  activeLang: LanguageCode;
  onChange: (lang: LanguageCode) => void;
}

// Better quality flags (using a simple emoji generic fallback if complex SVGs are too much, but let's try clean SVGs first)
// Actually, let's use simpler SVG structures that render reliably.

// Better quality flags (using a simple emoji generic fallback if complex SVGs are too much, but let's try clean SVGs first)
// Actually, let's use simpler SVG structures that render reliably.

const FlagBR = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 50"
    className="w-5 h-3.5 rounded-sm shadow-sm"
    aria-hidden="true"
  >
    <rect width="72" height="50" fill="#009c3b" rx="2" />
    <polygon points="36,6 66,25 36,44 6,25" fill="#ffdf00" />
    <circle cx="36" cy="25" r="10" fill="#002776" />
    <path d="M26,25 C26,25 32,30 46,20" stroke="#ffffff" strokeWidth="1.5" fill="none" />
  </svg>
);

const FlagUS = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 50"
    className="w-5 h-3.5 rounded-sm shadow-sm"
    aria-hidden="true"
  >
    <rect width="72" height="50" fill="#bd3d44" rx="2" />
    <rect y="7" width="72" height="7" fill="#fff" />
    <rect y="21" width="72" height="7" fill="#fff" />
    <rect y="35" width="72" height="7" fill="#fff" />
    <rect width="32" height="28" fill="#192f5d" rx="1" />
    <circle cx="8" cy="7" r="1" fill="#fff" />
    <circle cx="16" cy="7" r="1" fill="#fff" />
    <circle cx="24" cy="7" r="1" fill="#fff" />
    <circle cx="8" cy="14" r="1" fill="#fff" />
    <circle cx="16" cy="14" r="1" fill="#fff" />
    <circle cx="24" cy="14" r="1" fill="#fff" />
    <circle cx="8" cy="21" r="1" fill="#fff" />
    <circle cx="16" cy="21" r="1" fill="#fff" />
    <circle cx="24" cy="21" r="1" fill="#fff" />
  </svg>
);

const FlagES = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 50"
    className="w-5 h-3.5 rounded-sm shadow-sm"
    aria-hidden="true"
  >
    <rect width="72" height="50" fill="#aa151b" rx="2" />
    <rect y="12" width="72" height="26" fill="#f1bf00" />
  </svg>
);

const LANGUAGES: { code: LanguageCode; label: string; shortLabel: string; Icon: React.FC }[] = [
  { code: 'pt-BR', label: 'Português (Brasil)', shortLabel: 'PT', Icon: FlagBR },
  { code: 'en-US', label: 'English (US)', shortLabel: 'EN', Icon: FlagUS },
  { code: 'es-ES', label: 'Español', shortLabel: 'ES', Icon: FlagES },
];

export function LanguageSwitcher({ activeLang, onChange }: LanguageSwitcherProps) {
  return (
    <div className="bg-card p-3 sm:p-4 rounded-lg border border-border flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0 sticky top-4 z-40 shadow-sm transition-all text-center sm:text-left">
      <span className="text-sm font-medium text-foreground">Idioma de Edição:</span>
      <div className="flex gap-1 bg-muted p-1 rounded-lg w-full sm:w-auto justify-center">
        {LANGUAGES.map((lang) => {
          const isActive = activeLang === lang.code;
          return (
            <button
              key={lang.code}
              type="button"
              onClick={() => onChange(lang.code)}
              className="relative px-3 py-1.5 text-sm font-medium rounded-md transition-all outline-none focus-visible:ring-2 focus-visible:ring-primary"
            >
              {isActive && (
                <motion.div
                  layoutId="activeLang"
                  className="absolute inset-0 bg-background shadow-sm rounded-md"
                  transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                />
              )}
              <span
                className={`relative flex items-center gap-2 z-10 transition-colors ${isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground/80'}`}
              >
                <lang.Icon />
                <span className="hidden sm:inline">{lang.label}</span>
                <span className="inline sm:hidden">{lang.shortLabel}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
